module.exports = __webpack_public_path__ + "static/media/trial1.cc4fc287.mp3";